import { render, staticRenderFns } from "./examineDetail.vue?vue&type=template&id=48b2482c&scoped=true"
import script from "./examineDetail.vue?vue&type=script&lang=js"
export * from "./examineDetail.vue?vue&type=script&lang=js"
import style0 from "./examineDetail.vue?vue&type=style&index=0&id=48b2482c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b2482c",
  null
  
)

export default component.exports